import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductScreen from '../../shared/ProductScreen';
import AlertBox from 'imdui/src/components/field/AlertBox';

const MasteringMaintenance = () => {
  const { t } = useTranslation();

  return (
    <ProductScreen title={t('instant-mastering')}>
      <AlertBox
        type={AlertBox.Type.warning}
        title={t('instant-mastering-undergoing-maintenance')}
      />
    </ProductScreen>
  );
};

export default MasteringMaintenance;
